import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { first } from 'rxjs/operators';
import { CrewChangeRequestComponent } from 'src/app/front-user/services/CrewChange/crew-change-request/crew-change-request.component';
import { User } from 'src/app/front-user/shared/models/user.model';
import { BaseRequestService } from 'src/app/front-user/shipyard-service/services/base-request.service';
import { AlertService } from 'src/app/shared/components/alert/alert.service';
import { BaseRequest } from 'src/app/shared/models/base-request.model';
import { CrewChangeAdminDTO, RelatedTransitRequestsDTO } from 'src/app/shared/models/crewChange.model';
import { CCReviewerDecision, FormMode, Languages, Service, ServiceStatus } from 'src/app/shared/models/enums.model';
import { ResponseObject } from 'src/app/shared/models/response-object.model';
import { CrewChangeService } from 'src/app/shared/services/crewChange.service';
import { GlobalServices } from 'src/app/shared/services/global.service';

@Component({
  selector: 'app-crewchange-reviewer-decision',
  templateUrl: './crewchange-reviewer-decision.component.html',
  styleUrls: ['./crewchange-reviewer-decision.component.css']
})
export class CrewchangeReviewerDecisionComponent implements OnInit {

  submitted = false;
  loading = false;
  baseRequestId: string = '';
  requestStatus: number;
  baseRequestDTO: BaseRequest//= new BaseRequest();
  decision = CCReviewerDecision;
  decisionKeys = Object.keys(this.decision);
  displayedLang: string;
  decisionValue: number;
  crewChangeReviewerForm: FormGroup;
  currentUser: User = new User();
  adminDecisionObject: CrewChangeAdminDTO = new CrewChangeAdminDTO();
  showRequest = false;
  public FormMode: any = FormMode;
  public formMode: any = FormMode.Add;
  isLoaded: boolean = false;
  isErrorMessage: boolean = false;
  @ViewChild('CrewChangeRequest',{static: false}) CrewChangeRequest: CrewChangeRequestComponent;
  @Input() public isShow: boolean = true;
  responseObj: ResponseObject = new ResponseObject();
  lockTaskErrorMessage: boolean = false;
  relatedTransitRequestResponse: any;
  relatedTransitRequests: RelatedTransitRequestsDTO[];
  IMONO: string;
  loaderEnabled: boolean = false;
  showReviewerDecisionForm: boolean = true;
  isNotesRequired: boolean = false;

  constructor(
    private formBuilder: FormBuilder,
    private baseRequestService: BaseRequestService,
    private globalSrv: GlobalServices,
    private alertService: AlertService,
    private crewChangeService: CrewChangeService,
  ) {
    this.decisionKeys = this.decisionKeys.slice(this.decisionKeys.length / 2);
    this.displayedLang = this.globalSrv.getLanguage() == Languages.Arabic ? 'NameAR' : 'NameEN';
    if (history.state.data && history.state.data.requestId) {
      this.baseRequestId = history.state.data.requestId;
      this.getBaseRequest();
    } else {
      window.history.back();
    }
    this.currentUser = this.globalSrv.user;
  }

  ngOnInit() {
    this.buildForm();
  }

  buildForm() {
      this.crewChangeReviewerForm = this.formBuilder.group({
        Decision: ['', [Validators.required]],
        Notes: [''],
      });
  }
  get f() {
    return this.crewChangeReviewerForm.controls;
  }

  getIMONO(event) {
    this.IMONO = event;
    this.loadTransitRelatedRequests();
  }

  getBaseRequest() {
    this.baseRequestService.getBaseRequest(this.baseRequestId).subscribe(
      d => {
        this.baseRequestDTO = d.Data;
        this.requestStatus = this.baseRequestDTO.StatusId;
        // this.agentId = this.baseRequestDTO.RequestorId;
        this.isLoaded = true;
        if (this.requestStatus == ServiceStatus.CrewChange_PendingAgentApproval ||
          this.requestStatus == ServiceStatus.CrewChange_AcceptedByAgent ||
          this.requestStatus == ServiceStatus.CrewChange_RejectedByAgent) {
          this.showReviewerDecisionForm = false;
          }
        if ((history.state.data && history.state.data.isCompleted) || this.requestStatus == ServiceStatus.CrewChange_PendingApproval || this.requestStatus == ServiceStatus.CrewChange_PendingAgentApproval) {
          this.getCrewChangeRequest();
          this.formMode = FormMode.Readonly;
          this.crewChangeReviewerForm.disable();
        }
      }
    )
  }

  getCrewChangeRequest() {
    this.crewChangeService.getById(this.baseRequestId).pipe(first()).subscribe(
      (resObj: ResponseObject) => {
        this.responseObj = resObj;
        if (this.responseObj.Success) {
          this.buildForm();
          this.crewChangeReviewerForm.patchValue({
            Decision: this.responseObj.Data["ReviewerDecision"],
            Notes: this.responseObj.Data['ReviewerNotes']
          });
        }
      }

    );
  }
  loadTransitRelatedRequests(): void {
    this.loaderEnabled = true;
    this.crewChangeService.getTransitRelatedRequests(this.IMONO).subscribe(
      data => this.relatedTransitRequestResponse = data,
      () => console.log("Something went wrong!!"),
      () => this.loadTransitRelatedRequestsCompleted()
    );
  }
  loadTransitRelatedRequestsCompleted(): void {
    if (this.relatedTransitRequestResponse.Success) {
      this.relatedTransitRequests = this.relatedTransitRequestResponse.Data as RelatedTransitRequestsDTO[];
    }
    this.loaderEnabled = false;
  }

  relatedRequestDetails(relatedRequestIndex: number): void {
    localStorage.setItem('TransitRequestId', this.relatedTransitRequests[relatedRequestIndex].Id);
    window.open('#/transitRequest', '_blank');
  }

  changeDecision(value) {
    if (value == this.decision.MoreInformation || value == this.decision.Reject) {
      this.isNotesRequired = true;
      // this.crewChangeReviewerForm.updateValueAndValidity();
    } else {
      this.isNotesRequired = false;
    }
  }

  onSubmit(b) {
    this.submitted = true;
    // stop here if form is invalid
    if (this.crewChangeReviewerForm.invalid) {
      return;
    }
    this.alertService.clear();
    this.globalSrv.isLoaderEnabled = true;
    this.loading = true;
    this.adminDecisionObject.ReviewerDecision = this.crewChangeReviewerForm.controls['Decision'].value;
    this.adminDecisionObject.ReviewerNotes = this.crewChangeReviewerForm.controls['Notes'].value;
    this.adminDecisionObject.AdminEmail = this.currentUser.UserName;
    this.adminDecisionObject.Id = this.baseRequestId;

    this.crewChangeService.AddReviewerDecision(this.adminDecisionObject)
      .subscribe(
        (data: ResponseObject) => {
          if (data.Success) {
            this.globalSrv.isLoaderEnabled = false;
            this.crewChangeReviewerForm.reset();
            this.loading = false;
            this.showRequest = true;
            this.isErrorMessage = false;
          }
          else if (data.ErrorMessages.find(e => e == "TaskCompletedByAnotherUser") != null) {
            this.lockTaskErrorMessage = true;
            this.showRequest = true;
            this.globalSrv.isLoaderEnabled = false;
          }
          else {
            this.globalSrv.isLoaderEnabled = false;
            this.showRequest = true;
            this.isErrorMessage = true;
            this.loading = false;
          }

        });
  }
}
